<div class="fpr-report">
  <!-- Header / Actions -->
  <div class="report-header">
    <div class="header-left">
      <h2 class="title">
        {{ currentReportName || translationService.getCreateFprReportText() }}
      </h2>
      <div class="year-row">
        <mat-form-field appearance="outline" class="year-select-field">
          <mat-label>{{ translationService.getYearText() }}</mat-label>
          <mat-select
            [formControl]="reportYearCtrl"
            [disabled]="isEditMode || !!currentReportId"
            required
          >
            <mat-option [value]="2024">2024</mat-option>
            <mat-option [value]="2025">2025</mat-option>
            <mat-option [value]="2026">2026</mat-option>
            <mat-option [value]="2027">2027</mat-option>
            <mat-option [value]="2028">2028</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="tags-filter-field">
          <mat-label>{{ translationService.getTagsText() }}</mat-label>

          @if (!currentReportId) {
            <mat-chip-grid #reportTagsChipGrid aria-label="Selected tags">
              @for (tag of reportTagsCtrl.value; track tag) {
                <mat-chip-row (removed)="removeReportTag(tag)">
                  {{ tag }}
                  <button matChipRemove type="button" aria-label="Remove tag">
                    <mat-icon>cancel</mat-icon>
                  </button>
                </mat-chip-row>
              }
            </mat-chip-grid>

            <input
              matInput
              [formControl]="reportTagSearchCtrl"
              [matChipInputFor]="reportTagsChipGrid"
              [matChipInputSeparatorKeyCodes]="tagSeparatorKeysCodes"
              [matAutocomplete]="reportTagsAuto"
              [placeholder]="translationService.getSearchText()"
            />
            <mat-autocomplete
              #reportTagsAuto="matAutocomplete"
              (optionSelected)="addReportTag($event)"
            >
              @for (tag of filteredProductTags; track tag) {
                @if (!reportTagsCtrl.value.includes(tag)) {
                  <mat-option [value]="tag">{{ tag }}</mat-option>
                }
              }
            </mat-autocomplete>
          } @else {
            <input
              matInput
              [value]="reportTagsCtrl.value.join(', ')"
              disabled
            />
          }
        </mat-form-field>
      </div>
    </div>
    <div class="actions">
      @if (!isEditMode) {
        <button
          mat-stroked-button
          color="primary"
          (click)="onGenerateReport()"
          [disabled]="!reportYearCtrl.value"
        >
          <mat-icon>summarize</mat-icon>
          {{ translationService.getGenerateReportText() }}
        </button>
      }
      <button
        mat-stroked-button
        color="primary"
        (click)="openImportSheet()"
        [disabled]="!reportYearCtrl.value && !currentReportId"
      >
        <mat-icon>file_upload</mat-icon>
        {{ translationService.getImportText() }}
      </button>
      <button
        mat-stroked-button
        color="primary"
        [disabled]="!currentReportId"
        (click)="onDownloadRawData()"
      >
        <mat-icon>download</mat-icon>
        {{ translationService.getDownloadText() }}
      </button>
      <button
        mat-stroked-button
        color="primary"
        (click)="openMissingProducts()"
        [disabled]="!currentReportId"
      >
        <mat-icon>search</mat-icon>
        {{ translationService.getCheckMissingProductsText() }}
      </button>
      <button
        mat-stroked-button
        color="primary"
        (click)="openAddProvisionalRow()"
        [disabled]="!currentReportId"
        [matTooltip]="translationService.getAddExternalRowTooltipText()"
      >
        <mat-icon>add_circle</mat-icon>
        {{ translationService.getAddExternalRowText() }}
      </button>
      <button
        mat-stroked-button
        (click)="onSave()"
        [disabled]="!currentReportId"
      >
        <mat-icon>save</mat-icon>
        {{ translationService.getSaveText() }}
      </button>
      <button
        mat-flat-button
        color="accent"
        (click)="onPublish()"
        [disabled]="!currentReportId || isPublishing"
      >
        <mat-icon>publish</mat-icon>
        {{ translationService.getPublishText() }}
      </button>
    </div>
  </div>

  <!-- Tabs -->
  @if (currentReportId) {
    <mat-tab-group>
      <mat-tab label="{{ translationService.getPlasticsText() }}">
        <app-plastics
          [rows]="plasticRows"
          [isEditMode]="isEditMode"
          (patches)="onPlasticsPatches($event)"
          (editing)="onPlasticsEditing($event)"
        ></app-plastics>
      </mat-tab>

      <mat-tab label="{{ translationService.getRawResinsText() }}">
        <app-resins
          [rows]="resinRows"
          [isEditMode]="isEditMode"
          (patches)="onResinsPatches($event)"
          (editing)="onResinsEditing($event)"
        >
        </app-resins>
      </mat-tab>
    </mat-tab-group>
  }
</div>
